// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

// project imports
import DrawerHeaderStyled from './DrawerHeaderStyled';
import Logo from 'components/logo';
import logoIcon from 'assets/images/logo/simple-salamander.svg';

import useConfig from 'hooks/useConfig';
import { MenuOrientation } from 'config';

interface Props {
  open: boolean;
}

// ==============================|| DRAWER HEADER ||============================== //

export default function DrawerHeader({ open }: Props) {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  const { menuOrientation } = useConfig();
  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  return (
    <DrawerHeaderStyled
      open={open}
      sx={{
        minHeight: isHorizontal ? 'unset' : open ? 'auto' : '60px',
        width: isHorizontal ? { xs: '100%', lg: '424px' } : 'initial',
        paddingTop: isHorizontal ? { xs: '10px', lg: '0' } : open ? '24px' : '8px',
        paddingBottom: isHorizontal ? { xs: '18px', lg: '0' } : open ? '24px' : '8px',
        paddingLeft: isHorizontal ? { xs: '24px', lg: '0' } : open ? '15px' : 0,
        paddingRight: open ? '24px' : 0,
        flexDirection: open ? 'column' : 'row',
        alignItems: open ? 'flex-start' : 'center',
        justifyContent: open ? 'flex-start' : 'center',
      }}
    >
      {open ? (
        <Stack direction="row" spacing={1.5} alignItems="center" sx={{ width: '100%' }}>
          {/* Ícone circular com salamandra */}
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              bgcolor: '#1B4332', // Verde escuro Salamander (mesmo da imagem)
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            }}
          >
            <img 
              src={logoIcon} 
              alt="Salamander" 
              style={{ 
                width: '28px', 
                height: '28px', 
                objectFit: 'contain',
                filter: 'brightness(0) invert(1) sepia(1) saturate(3) hue-rotate(100deg) brightness(1.3)' // Torna a salamandra verde claro Salamander
              }} 
            />
          </Box>
          
          {/* Textos */}
          <Box sx={{ flex: 1, minWidth: 0, pt: 0.5 }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: 'text.primary',
                lineHeight: 1.3,
                mb: 0.25,
                fontSize: '1rem',
                whiteSpace: 'nowrap',
              }}
            >
              Portal <Box component="span" sx={{ color: 'primary.main' }}>Salamander</Box>
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: 'text.secondary',
                fontSize: '0.75rem',
                lineHeight: 1.3,
                display: 'block',
                whiteSpace: 'nowrap',
              }}
            >
              Sistema de Gestão de Pedidos
            </Typography>
          </Box>
        </Stack>
      ) : (
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: '50%',
            bgcolor: '#1B4332', // Verde escuro Salamander
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          }}
        >
          <img 
            src={logoIcon} 
            alt="Salamander" 
            style={{ 
              width: '24px', 
              height: '24px', 
              objectFit: 'contain',
              filter: 'brightness(0) invert(1) sepia(1) saturate(3) hue-rotate(100deg) brightness(1.3)'
            }} 
          />
        </Box>
      )}
    </DrawerHeaderStyled>
  );
}
